/**
 * Generated by scripts/build-emotes.mjs from assets/emotes/set.mjs.
 * Do not edit: run `npm run build:emotes` instead.
 *
 * `row` is the emote's row in public/emotes.png, `ms` the length of its whole
 * loop (0 for one that does not animate), and `codes` its shortcode in each
 * language - all of which work everywhere, whatever the reader's own language.
 */
export const TILE = 16;
export const FRAMES = 3;
export const EMOTES = [
  { row: 0, ms: 2100, codes: {"fi":"hymy","en":"smile"} },
  { row: 1, ms: 2100, codes: {"fi":"kaveri","en":"friend"} },
  { row: 2, ms: 750, codes: {"fi":"kippis","en":"cheers"} },
  { row: 3, ms: 750, codes: {"fi":"juhla","en":"party"} },
  { row: 4, ms: 750, codes: {"fi":"nauru","en":"laugh"} },
  { row: 5, ms: 600, codes: {"fi":"perkele","en":"rage"} },
  { row: 6, ms: 900, codes: {"fi":"tuli","en":"fire"} },
  { row: 7, ms: 900, codes: {"fi":"sydan","en":"heart"} },
  { row: 8, ms: 900, codes: {"fi":"sauna","en":"sauna"} },
  { row: 9, ms: 500, codes: {"fi":"lagi","en":"lag"} },
  { row: 10, ms: 0, codes: {"fi":"mykka","en":"muted"} },
  { row: 11, ms: 1200, codes: {"fi":"peukku","en":"thumbsup"} },
  { row: 12, ms: 1500, codes: {"fi":"mieti","en":"think"} },
  { row: 13, ms: 600, codes: {"fi":"shokki","en":"shock"} },
  { row: 14, ms: 1200, codes: {"fi":"kiitos","en":"thanks"} },
  { row: 15, ms: 750, codes: {"fi":"kuuluu","en":"hearme"} },
  { row: 16, ms: 0, codes: {"fi":"kamera","en":"cam"} },
  { row: 17, ms: 1500, codes: {"fi":"nakyy","en":"isee"} },
  { row: 18, ms: 600, codes: {"fi":"hei","en":"wave"} },
  { row: 19, ms: 1500, codes: {"fi":"salmiakki","en":"salmiakki"} },
  { row: 20, ms: 1200, codes: {"fi":"mokki","en":"cabin"} },
  { row: 21, ms: 1200, codes: {"fi":"lumi","en":"snow"} },
  { row: 22, ms: 900, codes: {"fi":"sisu","en":"sisu"} },
  { row: 23, ms: 750, codes: {"fi":"popcorn","en":"popcorn"} },
  { row: 24, ms: 0, codes: {"fi":"f","en":"f"} },
];

export default { TILE, FRAMES, EMOTES };
